<template>
  <div class="card col-span-12" >
    <q-scroll-area :visible="true" class="scroll " >
      <jt-dashboard :title="$gettext('DASHBORD_BY_TECHNOLOGY_TITLE')" class="full-height">
      <div class="card col-span-6 row-span-7 graph1">
        <residues-by-technology-pizza-graph @filter-button="openFilter" />
      </div>
      <div class="card col-span-6 row-span-7">
        <residues-by-technology-line-graph @filter-button="openFilter" />
      </div>
      <div class="card col-span-12 row-span-6">
        <residues-by-residue-and-technology-line-graph @filter-button="openFilter" />
      </div>
    </jt-dashboard>
  </q-scroll-area>
  </div>
</template>

<script>
import JtDashboard from './base/JtDashboard.vue'
import { Component, Vue } from 'vue-property-decorator'
import ResiduesByTechnologyPizzaGraph from './ResiduesByTechnologyPizzaGraph.vue'
import ResiduesByTechnologyLineGraph from './ResiduesByTechnologyLineGraph.vue'
import ResiduesByResidueAndTechnologyLineGraph from './ResiduesByResidueAndTechnologyLineGraph.vue'
import { QScrollArea } from 'quasar'

@Component({
  name: 'technologyDashboard',
  components: {
    JtDashboard,
    ResiduesByTechnologyLineGraph,
    ResiduesByTechnologyPizzaGraph,
    ResiduesByResidueAndTechnologyLineGraph,
    QScrollArea
  }
})
export default class TechnologyDashboard extends Vue {

}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

.filter-button {
  position:absolute;
}
.graph1 {
  position:relative;
}
.scroll {
  height: calc(100vh - 100px);
  width: 100%;
  background-color: #EBEBEB;
  border-radius: 4px;
  padding: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}
.full-height {
  height: 100%;
  display: flex;
  flex-direction: column;
}

</style>
